import { Navigate } from "react-router-dom";
import { useAppSelector } from "../hooks/useAppSelector";
import { canScanQr, isAdmin, isSuperAdmin } from "../helpers/roles";

/**
 * SUPERADMIN-only guard for guest-events / guest-event.
 * Redirect priority: canScanQr → /qr-scanner; isAdmin → /; else → /404.
 */
function SuperAdminRoute({ children }) {
  const user = useAppSelector((state) => state.auth.user);
  const rol = user?.rol;

  if (isSuperAdmin(rol)) {
    return children;
  }

  if (canScanQr(rol)) {
    return <Navigate to="/qr-scanner" replace />;
  }

  if (isAdmin(rol)) {
    return <Navigate to="/" replace />;
  }

  return <Navigate to="/404" replace />;
}

export { SuperAdminRoute };
